export const categories = [
  { id: 'star-scandal', name: '明星黑料', slug: 'star-scandal', description: '最新明星八卦、内幕爆料与深度挖掘', icon: 'ri-star-line' },
  { id: 'entertainment', name: '娱乐圈内幕', slug: 'entertainment', description: '圈内人士独家揭秘娱乐圈运作内幕', icon: 'ri-movie-line' },
  { id: 'influencer-fail', name: '网红翻车', slug: 'influencer-fail', description: '网红直播翻车、人设崩塌事件盘点', icon: 'ri-live-line' },
  { id: 'exclusive', name: '独家爆料', slug: 'exclusive', description: '黑料社区独家挖掘的劲爆内幕消息', icon: 'ri-fire-line' },
];

export const articles = [
  {
    id: '20240801-001',
    title: '某顶流小生深夜密会神秘女子，酒店共度8小时全程被拍',
    excerpt: '据知情人士透露，该顶流小生近日被拍到与一位神秘女子在某五星级酒店共度良宵，两人举止亲密，引发网友热议。该男子全程口罩帽子遮面，但仍被眼尖粉丝认出。',
    content: `<p>近日，有网友在社交平台爆料称，拍到某当红顶流小生深夜与一名神秘女子在某五星级酒店密会。据悉，两人在酒店大堂碰面后，一同乘坐电梯进入房间，直到次日清晨才分别离开。</p>
    <p>据拍摄者描述，该男子虽然全程戴着口罩和帽子试图遮挡面容，但其标志性的身高体态以及身上的限量款穿搭，几乎可以确定就是那位近期频繁登上热搜的流量明星。</p>
    <p>消息一出，立即引发网友热议。有粉丝表示"这明显是AI合成图，不要造谣"，也有网友认为"明星也是人，恋爱自由没什么不好"。截至目前，该男星的工作室尚未对此事作出回应。</p>
    <p>值得注意的是，这位男星此前曾在多个公开场合表示自己是单身状态，如果此次爆料属实，恐怕又将成为一桩"说谎翻车"的典型案例。</p>
    <p>黑料社区将持续关注此事的后续发展，为大家带来第一手消息。</p>`,
    category: 'star-scandal',
    author: '黑料调查员',
    date: '2024-08-01',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20figure%20in%20a%20luxury%20hotel%20lobby%20at%20night%2C%20dramatic%20moody%20lighting%2C%20paparazzi%20style%20photography%2C%20silhouette%20with%20warm%20hotel%20lights%2C%20cinematic%20noir%20atmosphere%2C%20dark%20tones%20with%20golden%20accents%2C%20editorial%20composition%2C%20low%20light%20scene%20with%20bokeh%20background&width=800&height=500&seq=article-star-001&orientation=landscape',
    views: 128930,
    comments: 3421,
    tags: ['顶流', '密会', '酒店', '绯闻'],
    featured: true,
  },
  {
    id: '20240802-002',
    title: '某综艺节目录制现场爆发激烈冲突，导演组紧急叫停',
    excerpt: '据现场工作人员爆料，某热门综艺节目最新一期录制过程中，两位常驻嘉宾因游戏环节产生矛盾，现场爆发激烈口角，导致节目录制被迫中断近两个小时。',
    content: `<p>娱乐圈的综艺节目向来以和谐欢乐示人，但镜头背后的真实情况可能远非如此。据一位不愿透露姓名的现场工作人员向黑料社区爆料，某档收视率极高的综艺节目在最新一期录制中发生了严重冲突事件。</p>
    <p>"当时正在进行一个团队对抗游戏环节，两位常驻嘉宾因为对规则的理解产生分歧，一开始只是小声争论，但不知怎么就升级成了激烈的口角，甚至差点动手。"该工作人员回忆道。</p>
    <p>据悉，导演组见势不妙立即叫停了录制，将两位嘉宾分别带到不同休息室进行安抚和沟通。整个节目组因此停工近两个小时，其他嘉宾和现场观众只能在原地等待。</p>
    <p>经过导演组的协调，两位嘉宾最终回到录制现场并向观众表达了歉意，但整个后半场的录制气氛明显变得尴尬。这段冲突画面大概率不会在正片中播出，但现场观众拍下的模糊视频已经在网络上悄悄流传。</p>
    <p>这并非该节目首次传出内部矛盾，早前就有网友发现某两位嘉宾在社交平台上互相取关，如今看来矛盾可能早已存在。</p>`,
    category: 'entertainment',
    author: '圈内知情人',
    date: '2024-08-02',
    image: 'https://readdy.ai/api/search-image?query=A%20television%20studio%20set%20with%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20empty%20stage%20with%20scattered%20equipment%2C%20tense%20atmosphere%2C%20behind%20the%20scenes%20of%20a%20variety%20show%2C%20cinematic%20photography%2C%20dark%20corners%20with%20spotlights%2C%20editorial%20style&width=800&height=500&seq=article-tv-002&orientation=landscape',
    views: 98654,
    comments: 2876,
    tags: ['综艺', '冲突', '录制事故', '嘉宾矛盾'],
    featured: true,
  },
  {
    id: '20240803-003',
    title: '百万粉丝网红直播带货翻车，产品质量遭集体投诉',
    excerpt: '某拥有超过500万粉丝的头部网红近日直播带货时，所售产品被大量粉丝投诉存在严重质量问题，该网红直播间评论区一度被愤怒的消费者刷屏。',
    content: `<p>"家人们，这个产品我自己用了很久，绝对好用到爆炸！"这是那位头部网红在直播带货时的原话。然而，当粉丝们满怀期待收到产品后，等待他们的却是严重的质量问题和令人失望的售后体验。</p>
    <p>据黑料社区多位读者投稿反映，该网红在直播间推荐的一款护肤品，使用后出现了不同程度的过敏反应，包括红肿、瘙痒、起疹等症状。更令人气愤的是，消费者联系客服要求退货时，却被告知"已拆封使用不支持退换"。</p>
    <p>"这不是在割韭菜吗？嘴上说着家人们，背地里却卖这种劣质产品！"一位受影响的消费者在黑料社区发帖表示。目前，相关投诉帖子的浏览量已突破50万，越来越多的消费者站出来分享自己的遭遇。</p>
    <p>面对铺天盖地的批评声浪，该网红至今未作出正面回应，只是在直播中含糊表示"会调查产品质量问题"。其直播间下架了涉事产品，但并未向已购买的用户提供明确的补偿方案。</p>
    <p>这并非个例。近年来，随着直播带货行业的爆发式增长，网红翻车事件层出不穷。黑料社区提醒广大消费者：理性消费，慎信直播话术。</p>`,
    category: 'influencer-fail',
    author: '消费观察员',
    date: '2024-08-03',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20livestream%20setup%20with%20ring%20light%20and%20products%20scattered%2C%20dark%20moody%20atmosphere%2C%20contrast%20between%20bright%20screen%20and%20shadow%2C%20consumer%20products%20in%20disarray%2C%20editorial%20photography%2C%20warm%20and%20cool%20color%20contrast&width=800&height=500&seq=article-live-003&orientation=landscape',
    views: 76542,
    comments: 2198,
    tags: ['直播带货', '翻车', '产品质量', '消费者维权'],
    featured: true,
  },
  {
    id: '20240804-004',
    title: '独家：某影视公司内部邮件曝光，涉及多位艺人合约纠纷',
    excerpt: '黑料社区独家获取一份某知名影视公司的内部邮件，邮件内容显示该公司目前正与多位一线艺人陷入合约纠纷，涉及金额或达数亿元。',
    content: `<p>黑料社区独家获得一份某头部影视公司的内部工作邮件（为保护爆料人身份，具体公司名称和细节已做脱敏处理），邮件内容显示这家公司正与旗下多位签约艺人进行紧张的合约谈判，部分谈判已陷入僵局。</p>
    <p>邮件中提到，至少有三位一线演员对现有分成比例表示不满，要求重新签订合约提高个人收益分配。其中一位更是直接提出了"解约"的诉求，理由是公司未能按照合同约定提供足够优质的影视资源。</p>
    <p>"公司已经为TA投入了巨大的资源和资金，但TA近两年的作品表现确实不尽如人意。"邮件中的这句话暗示了这场合约纠纷背后复杂的利益博弈。</p>
    <p>业内分析人士指出，近年来随着短视频和网络剧的兴起，传统影视公司的商业模式受到冲击，头部艺人的议价能力却在不断增强，这种供需关系的失衡是导致合约纠纷频发的根本原因。</p>
    <p>如果这几位艺人最终选择解约，不仅会给该影视公司带来巨大的经济损失，更可能引发行业内的连锁反应。黑料社区将持续追踪此事件的后续进展。</p>`,
    category: 'exclusive',
    author: '黑料调查员',
    date: '2024-08-04',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20office%20scene%20with%20confidential%20documents%20on%20a%20dark%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20legal%20papers%20and%20envelopes%2C%20cinematic%20noir%20style%2C%20rich%20dark%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-contract-004&orientation=landscape',
    views: 89320,
    comments: 3120,
    tags: ['合约纠纷', '影视公司', '艺人解约', '独家爆料'],
    featured: false,
  },
  {
    id: '20240805-005',
    title: '某女星被曝与富商低调完婚，婚礼现场照片流出',
    excerpt: '有网友爆料某知名女星已于上月与一位地产富商在国外秘密举办婚礼，现场照片显示婚礼规模虽小但极尽奢华，仅邀请至亲好友参加。',
    content: `<p>娱乐圈又一位女星低调完婚！据黑料社区收到的独家爆料，某知名女演员已于上月在某海岛国家与一位地产行业富商举行了秘密婚礼。</p>
    <p>曝光的婚礼现场照片显示，虽然到场宾客人数不多，但婚礼布置极尽精致奢华。新娘身着一袭定制婚纱，手捧进口鲜花，面带幸福笑容。据悉，婚礼场地是该富商名下的私人庄园，整个婚礼花费预计超过八位数。</p>
    <p>有意思的是，这位女星一个月前还在公开活动中被问及感情状况时，她的回答是"目前还是以事业为重"。如今看来，这句话不过是娱乐圈常见的"安全回答"罢了。</p>
    <p>该女星近年来影视作品产量明显减少，坊间一直有传闻她正在与圈外人士交往，但始终没有明确证据。这次婚礼照片的流出，似乎为这些传闻画上了一个句号。</p>
    <p>黑料社区在此恭喜这对新人，但也忍不住问一句：下次能提前通知一下吗？我们好准备份子钱啊！</p>`,
    category: 'star-scandal',
    author: '八卦小能手',
    date: '2024-08-05',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20luxury%20wedding%20scene%20at%20a%20tropical%20beach%20resort%2C%20elegant%20white%20floral%20decorations%2C%20golden%20sunset%20lighting%2C%20intimate%20ceremony%20setting%2C%20soft%20warm%20tones%2C%20editorial%20wedding%20photography%20style%2C%20dreamy%20atmosphere&width=800&height=500&seq=article-wedding-005&orientation=landscape',
    views: 65430,
    comments: 1876,
    tags: ['女星结婚', '富商', '秘密婚礼', '海岛婚礼'],
    featured: true,
  },
  {
    id: '20240806-006',
    title: '热门网剧男主角被曝片场耍大牌，多名工作人员实名吐槽',
    excerpt: '凭借某爆款网剧走红的男演员最近被多位剧组工作人员实名吐槽，称其在片场态度恶劣、经常迟到、对工作人员呼来喝去。',
    content: `<p>一夜爆红之后，有些人能保持初心，有些人却迅速"膨胀"了。近日，多位曾与某热门网剧男主角合作过的工作人员向黑料社区实名反映，这位凭借该网剧一举成名的男演员在片场素有"难搞"的名声。</p>
    <p>"迟到半小时是常态，来了还要在化妆间磨蹭半天。全剧组等他一个人是家常便饭。"一位化妆师在投稿中写道。另一位场务人员则表示："他对待工作人员的态度真的很差，动不动就发脾气骂人。有一次因为盒饭不合口味，直接把整盒饭摔在了地上。"</p>
    <p>更令人惊讶的是，一位曾与他合作过的导演助理透露，这位男演员还曾因为不满意摄像机的机位角度，直接威胁罢演，最后导演不得不妥协按照他的要求重新布景。</p>
    <p>这些爆料在网络上迅速发酵，短时间内"XXX耍大牌"的话题就登上了热搜。该男演员的工作团队随后发布了声明，称这些爆料"纯属造谣"，但没有拿出任何实质性证据来反驳。</p>
    <p>对于这类"红了就飘"的现象，网友们看法不一。有人认为这是年轻演员不成熟的表现，也有人质疑这些爆料的真实性。你觉得呢？</p>`,
    category: 'entertainment',
    author: '圈内知情人',
    date: '2024-08-06',
    image: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20professional%20camera%20equipment%20and%20lighting%20rigs%2C%20empty%20directors%20chair%2C%20dramatic%20contrast%20between%20bright%20set%20lights%20and%20dark%20corners%2C%20behind%20the%20scenes%20cinema%20production%2C%20warm%20and%20cool%20mixed%20lighting%2C%20editorial%20photography&width=800&height=500&seq=article-set-006&orientation=landscape',
    views: 112430,
    comments: 4521,
    tags: ['耍大牌', '网剧', '片场', '工作人员吐槽'],
    featured: false,
  },
  {
    id: '20240807-007',
    title: '知名美妆博主被扒学历造假，人设崩塌引发粉丝脱粉潮',
    excerpt: '拥有千万粉丝的美妆博主近日被网友扒出学历造假，其自称的某海外名校硕士学历根本不存在，该博主随后发视频道歉但未能平息众怒。',
    content: `<p>在这个看脸的时代，连学历都可以P。拥有超过千万粉丝的美妆博主"XXX"近日遭遇了职业生涯以来最大的人设危机——被网友扒出她引以为傲的海外名校硕士学历竟然不存在。</p>
    <p>事情的起因是一位留学生在社交平台上对这位博主提到的学校产生了怀疑。"她说自己是XX大学的硕士，但这所学校的硕士项目根本不招收来自她本科学校的学生。"这位留学生详细列出了该校的招生要求和课程设置，直接打了博主的脸。</p>
    <p>随着越来越多的人加入"扒皮"行列，博主的学历造假证据被一一呈现：学校官网上找不到她的名字、学生系统中搜索不到她的信息、连她发过的"校园照"都被发现是在该城市的旅游打卡点拍摄的。</p>
    <p>眼看事情越闹越大，该博主发布了一条道歉视频，承认自己在早期为了"塑造更好的个人形象"而美化了简历。但这一迟来的道歉并没有获得粉丝的原谅，视频下方的评论区被各种失望和愤怒的留言淹没，粉丝数量一夜之间骤降数十万。</p>
    <p>在当下这个内容创作者与粉丝之间越来越注重"真实感"的时代，任何造假行为都可能成为致命一击。黑料社区提醒各位创作者：诚实，或许才是最好的内容策略。</p>`,
    category: 'influencer-fail',
    author: '消费观察员',
    date: '2024-08-07',
    image: 'https://readdy.ai/api/search-image?query=A%20makeup%20influencer%20studio%20setup%20with%20vanity%20mirror%20and%20ring%20light%2C%20diploma%20certificates%20scattered%20on%20a%20desk%2C%20dramatic%20side%20lighting%2C%20contrast%20between%20beauty%20and%20truth%2C%20dark%20aesthetic%20with%20warm%20accents%2C%20editorial%20photography&width=800&height=500&seq=article-diploma-007&orientation=landscape',
    views: 145670,
    comments: 6721,
    tags: ['学历造假', '人设崩塌', '脱粉', '美妆博主'],
    featured: true,
  },
  {
    id: '20240808-008',
    title: '某音乐节主办方被曝拖欠艺人演出费，多位歌手联合维权',
    excerpt: '一家知名音乐节主办方近日被多位参演歌手联合指控拖欠演出费用，总金额或超千万。据悉，该主办方已多次以"资金周转困难"为由拖延支付。',
    content: `<p>音乐节本该是歌迷和歌手共同享受的狂欢盛宴，但幕后的商业纠纷却可能让这场盛宴变了味。黑料社区独家获悉，一家在国内颇有影响力的音乐节主办方正面临多位参演艺人的联合维权。</p>
    <p>据一位涉事歌手的经纪人透露，该主办方在今年举办的几场大型音乐节活动中，至今未支付超过十位歌手的演出费用，累计拖欠金额或超过千万元。"合同上白纸黑字写的付款日期早就过了，每次催款对方都说'在走流程、资金周转困难'，已经拖了好几个月了。"</p>
    <p>更令人震惊的是，有消息称该主办方在拖欠艺人费用的同时，却在积极筹备下一场音乐节活动并已经开始售票。这意味着他们将用新活动的票款来填补之前的窟窿，这种"拆东墙补西墙"的做法无疑是在走钢丝。</p>
    <p>目前，涉事歌手们已经联合委托了律师团队，准备通过法律途径解决这一问题。如果此事最终对簿公堂，该主办方的音乐节品牌信誉将受到毁灭性打击。</p>
    <p>黑料社区在此提醒所有艺人：签合同时务必仔细审查对方的商业信用和履约能力，保护自己的合法权益。</p>`,
    category: 'exclusive',
    author: '黑料调查员',
    date: '2024-08-08',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20empty%20music%20festival%20stage%20at%20night%2C%20unplugged%20instruments%20and%20equipment%2C%20dramatic%20moody%20lighting%2C%20abandoned%20concert%20venue%2C%20contrast%20between%20stage%20lights%20and%20darkness%2C%20editorial%20photography%2C%20cinematic%20composition&width=800&height=500&seq=article-concert-008&orientation=landscape',
    views: 54320,
    comments: 1654,
    tags: ['音乐节', '拖欠费用', '艺人维权', '合同纠纷'],
    featured: false,
  },
  {
    id: '20240809-009',
    title: '某知名导演被多名女演员指控骚扰，业内掀起MeToo第二波',
    excerpt: '一位曾执导过多部票房大片的知名导演近日被至少五名女演员实名指控性骚扰，该导演已宣布退出正在筹备的新片项目。',
    content: `<p>娱乐圈的MeToo运动从未真正平息。近日，一位在电影圈颇具声望的知名导演被多名女演员实名指控性骚扰，让这个话题再次成为公众焦点。</p>
    <p>第一位站出来发声的是一位年轻的实力派女演员，她在社交平台上发布千字长文，详细描述了在试镜和拍摄过程中遭遇的不当行为。"他说这是'行业潜规则'，说如果我不配合就别想在这个圈子里混下去。"这段令人窒息的自述在发布后迅速获得了数百万次浏览和数万条评论。</p>
    <p>在她的勇气感召下，随后几天内又有四位女演员站出来分享了自己与该导演合作时的类似遭遇。她们描述的套路高度一致：以"讨论角色"为由进行单独约谈，然后逐渐越界。</p>
    <p>舆论压力之下，该导演通过工作室发布了简短声明，否认了部分指控但表示"为了不影响作品和团队，自愿退出正在筹备的新片项目"。不过，这显然不是公众想要的态度，网友们纷纷要求他正式道歉而非"低调退出"。</p>
    <p>事实上，这已是近两年来第三起涉及知名导演的骚扰指控事件。黑料社区认为，只有行业建立更加透明和公正的监督机制，才能真正杜绝此类事件的发生。</p>`,
    category: 'entertainment',
    author: '圈内知情人',
    date: '2024-08-09',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20empty%20film%20studio%20with%20a%20single%20spotlight%2C%20dramatic%20contrast%20between%20light%20and%20shadow%2C%20cinematic%20noir%20atmosphere%2C%20empty%20directors%20chair%20in%20the%20spotlight%2C%20editorial%20photography%2C%20powerful%20visual%20metaphor&width=800&height=500&seq=article-metoo-009&orientation=landscape',
    views: 187430,
    comments: 8921,
    tags: ['MeToo', '性骚扰', '导演', '女演员维权'],
    featured: true,
  },
  {
    id: '20240810-010',
    title: '某电商平台头部主播偷税被查，补缴税款及罚款超两亿',
    excerpt: '据知情人士透露，某电商平台头部带货主播因涉嫌偷逃税款正接受税务部门调查，需补缴税款及罚款合计超过两亿元人民币。',
    content: `<p>直播带货行业的税务风暴仍在继续。黑料社区从多个可靠渠道获悉，某电商平台的头部带货主播近日因涉嫌偷逃税款，正在接受税务部门的调查，需补缴的税款及罚款总额或将超过两亿元人民币。</p>
    <p>据悉，税务部门在例行大数据比对过程中发现了该主播申报的收入与实际带货流水存在巨大差异。进一步调查发现，该主播通过设立多家空壳公司、虚构成本支出等方式，大量转移和隐匿直播收入。</p>
    <p>"这已经不是个案了。自从XX被查之后，税务部门对整个直播带货行业的监管力度明显加强。"一位税务领域的专业人士向黑料社区表示。事实上，过去两年已有多位知名主播因税务问题被查处，其中最高的一案补税及罚款金额接近14亿元。</p>
    <p>该主播目前尚未被正式通报，但多个品牌方已经紧急下架了与其合作的商品链接，显然是收到了风声。其直播间也已经停播超过一周，官方给出的理由是"设备升级维护"。</p>
    <p>合法纳税是每个公民应尽的义务，无论收入多高、人气多旺，都不能成为逃避税收监管的理由。黑料社区将持续关注此事的官方通报。</p>`,
    category: 'influencer-fail',
    author: '消费观察员',
    date: '2024-08-10',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20office%20with%20financial%20documents%20and%20tax%20forms%20scattered%20on%20a%20desk%2C%20dramatic%20lighting%20from%20a%20desk%20lamp%2C%20calculators%20and%20money%2C%20moody%20noir%20atmosphere%2C%20warm%20and%20dark%20contrast%2C%20editorial%20photography&width=800&height=500&seq=article-tax-010&orientation=landscape',
    views: 99870,
    comments: 4120,
    tags: ['偷税', '直播带货', '罚款', '税务调查'],
    featured: false,
  },
];